import React from 'react'
import { useTranslation } from 'react-i18next'
import { Package } from 'lucide-react'
import notDateIcon from '../../assets/images/notDate.svg'

interface CSPlaceholderProps {
  isRTL?: boolean
  className?: string
}

const CSPlaceholder: React.FC<CSPlaceholderProps> = ({
  isRTL = false,
  className = ''
}) => {
  const { t } = useTranslation()

  return (
    <div className={`
      h-full flex flex-col items-center justify-center text-center py-12
      ${className}
    `}>
      {/* Main Icon */}
      <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <img src={notDateIcon} alt="No Address" />
      </div>

      {/* Main Message */}
      <h3 className="text-lg font-medium text-gray-600 mb-2 font-['IBM Plex Sans Arabic']">
        {t('cs.select_customer_and_order_type_first')}
      </h3>
    </div>
  )
}

export default CSPlaceholder









